<template>
  <div>{{ timeLeft }}</div>
</template>

<script>
  export default {
    props: {
      value: {
        default: 300
      }
    },
    data() {
      return {
        time: 10, //in seconds
        timer: null,
      }
    },
    methods: {
      decrementOrAlert () {
        if (this.time > 0) {
          this.time--
          return
        }

        this.$emit('timeout');
        clearInterval(this.timer)
      }
    },
    computed: {
      timeLeft () {
        return `${this.minutes} : ${this.seconds}`
      },
      minutes () {
        return String(Math.floor(this.time / 60)).padStart(2, '0')
      },
      seconds () {
        return String(this.time % 60).padStart(2, '0')
      }
    },
    created () {
      this.time = this.value
      this.timer = setInterval(this.decrementOrAlert, 1000)
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/Countdown/Timer.vue